export default __webpack_public_path__ + "static/Card12-606b8ae0b67d4e8809dc7b329705f45a.png";